import { render } from "./CookieBanner.vue?vue&type=template&id=52c3546d&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import "./CookieBanner.vue?vue&type=style&index=0&id=52c3546d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52c3546d"

export default script